<template>
  <ul>
    <li
      class="px-2 mt-6"
      v-for="locale in locales"
      :key="locale.value"
      @click="switchLocale(locale.value)"
    >
      <span :style="{ color: getColor }">{{ locale.text }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "LocaleSwitcher",
  props: {
    color: String,
  },
  computed: {
    getColor() {
      if (this.color) {
        return this.color + " !important";
      } else {
        return "var(--color-text) !important";
      }
    },
  },
  methods: {
    switchLocale(locale) {
      if (this.$i18n.locale !== locale) {
        this.$i18n.locale = locale;
        this.$vuetify.lang.current = locale
        if (locale === "fa") {
          this.$vuetify.rtl = true;
        } else {
          this.$vuetify.rtl = false;
        }
      }
    },
  },
  data() {
    return {
      locales: [
        { value: "fa", text: "فارسی" },
        { value: "en", text: "English" },
      ],
    };
  },
};
</script>

<style scoped>
ul {
  display: flex;
  justify-content: center;
}
li {
  text-decoration: none;
  cursor: pointer;
  display: inline;
}
</style>